import React from "react";
import DownloadTracking from "../DownloadReport/tracking";

export default function HallTicketTracking() {
  return (
    <DownloadTracking
      apiPath="backoffice/hallticket"
      documentLabel="Hall Ticket"
      // Excel export of downloaded candidates (click on the "Downloaded" card) is
      // switched OFF for now. The feature is fully built - set to true to re-enable.
      canExportDownloaded={false}
    />
  );
}
